module.exports = __webpack_public_path__ + "static/media/bathroom.6402aea7.svg";